module.exports = __webpack_public_path__ + "static/media/img33.65086aa1.jpg";